import { createSlice } from "@reduxjs/toolkit"
import { setLocalStorageItem } from "../../utils/local_storage/local_storage"

import { OrderModel } from "../../models/order.model"
// import { TableOrderModel } from "../../models/table_order.model"
import type { PayloadAction } from "@reduxjs/toolkit"

const initialState = OrderModel

const getSubTotal = (products: any) => {
    const total = products.reduce((acc: number, currProd: any) => {
        return acc + currProd.totalPrice
    }, 0)

    return total
}

const getTotalProducts = (products: any) => {
    return products.reduce((acc: any, curr: any) => acc + curr.qty, 0)
}

const updateCartLocalStorage = (state: any) => {
    setLocalStorageItem(
        "cart",
        {
            cart: {
                total: state.cart.total,
                subtotal: state.cart.subtotal,
                total_products: state.cart.total_products,
                products: state.cart.products
            },
            details: {
                customer_data: state.details.customer_data,
                payment_method: state.details.payment_method,
                order_type: state.details.order_type,
                tip: state.details.tip,
                shipping_fee: state.details.shipping_fee,
                table: state.details.table,
            }
        }
    )
}

export const shopOrderSlice = createSlice({
    name: "shopOrder",
    initialState,
    reducers: {
        addProduct: (state, action: any) => {
            state.cart.products.push(action.payload)
            const subtotal = getSubTotal(state.cart.products)
            state.cart.subtotal = subtotal
            state.cart.total = subtotal + state.details.shipping_fee + state.details.tip
            state.cart.total_products = getTotalProducts(state.cart.products)
            updateCartLocalStorage(state)
        },
        removeProduct: (state, action: PayloadAction<CartProductType["uuid"]>) => {
            const index = state.cart.products.findIndex(product => product.uuid === action.payload)
            state.cart.products.splice(index, 1)
            const subtotal = getSubTotal(state.cart.products)
            state.cart.subtotal = subtotal
            state.cart.total = subtotal + state.details.shipping_fee + state.details.tip
            state.cart.total_products = getTotalProducts(state.cart.products)
            updateCartLocalStorage(state)
        },
        clearCart: (state) => {
            state.cart = OrderModel.cart
            updateCartLocalStorage(state)
        },
        updateCartInitialState: (state, action: PayloadAction<ShopOrderType>) => {
            state.cart = action.payload.cart
            state.details = action.payload.details
        },
        setTableId: (state, action: PayloadAction<number | null>) => {
            state.details.table = action.payload
        },


        // Refactor >>>
        // updateCartTip: (state, action) => {
        //     const newPercentage = action.payload
        //     state.tip.percentage = newPercentage
        //     const tipTotal = getTipAmount(parseFloat(state.subtotal), newPercentage)
        //     state.tip.total = tipTotal
        //     state.total = parseFloat(state.subtotal) + state.shipping_fee + parseFloat(tipTotal)
        // },
    },
})

export const {
    addProduct,
    removeProduct,
    clearCart,
    updateCartInitialState,
    setTableId,
    // updateCartTip,
} = shopOrderSlice.actions